import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import ProjectPage from '../../components/ProjectPage'

const projectElements = {
	images: [
	  {
	    "src": "AnalogAlphabet/art",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/broken",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/childhood",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/dirt",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/exit",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/fire",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/glass",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/house",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/i",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/joy",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/kitchen",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/lost",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/mirror",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/newspaper",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/odd",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/people",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/quiet",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/rain",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/snail",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/trangle",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/uni",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/vibration",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/water",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/x",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/yellow",
	    "orientation": "landscape"
	  },
	  {
	    "src": "AnalogAlphabet/zero",
	    "orientation": "landscape"
	  }
	]
}

export default class Paper extends React.Component{
	render(){
		return(
			<ProjectPage 
			title="Analog Alphabet" 
			text={`Anstatt Fotos für nur ein bestimmtes Thema zu machen, wollte ich mir die Möglichkeit geben viele kleine Bildthemen zu haben. Dieses Konzept hat mit mehr Freiheiten innerhalb eines Projektes gegeben. 26 Buchtaben, 26 Wörter und 26 Bilder.`} 
			images={projectElements.images}/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/pages/projects/alphabet.js